var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { useApolloClient, useLazyQuery } from '@apollo/client';
import { withReviewPlugin } from 'shared/domains/documents/components/Preview/Pleditor/plugins/Review';
import { GET_REDLINE_HIGHLIGHT, GET_REVIEW_FEEDBACK_SOURCES } from './query';
export const useReviewSources = (feedbackId) => {
    var _a;
    const [fetchSources, { data, loading }] = useLazyQuery(GET_REVIEW_FEEDBACK_SOURCES, {
        variables: { feedbackId },
    });
    console.log(loading, data);
    return {
        fetchSources,
        // TODO: use data and query state for state
        // eslint-disable-next-line no-nested-ternary
        state: loading ? 'loading' : data ? 'loaded' : 'idle',
        sources: (_a = data === null || data === void 0 ? void 0 : data.feedbackSources) !== null && _a !== void 0 ? _a : [],
    };
};
export const useRedlines = (quote) => {
    const client = useApolloClient();
    const fetchRedlines = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const html = withReviewPlugin(p => { var _a; return (_a = p.editor.ui.getEditableElement()) === null || _a === void 0 ? void 0 : _a.innerHTML; });
        if (!html)
            return [];
        const res = yield client.query({
            query: GET_REDLINE_HIGHLIGHT,
            variables: { html, quote },
        });
        return (_a = res === null || res === void 0 ? void 0 : res.data.sourceRedlines) !== null && _a !== void 0 ? _a : [];
    }), [client, quote]);
    return { fetchRedlines };
};
